import { NgModule } from '@angular/core';
import { Routes, RouterModule } from '@angular/router';
import { HomeGuard } from './shared/guards/home.guard';

const appRoutes: Routes = [
  {
    path: '',
    canActivate: [HomeGuard],
    loadChildren: 'app/landing/landing.module#LandingModule'
  },
  {
    path: 'reporting',
    loadChildren: 'app/reporting/reporting.module#ReportingModule'
  },
  {
    path: 'dashboard',
    loadChildren: 'app/dashboard/dashboard.module#DashboardModule'
  }
];

@NgModule({
  imports: [
    RouterModule.forRoot(appRoutes, {
      // useHash: true,
      // enableTracing: true // <-- debugging purposes only,
    })
  ],
  exports: [RouterModule]
})
export class AppRoutingModule {}



// WEBPACK FOOTER //
// ./src/app/app-routing.module.ts